import { isEmail } from 'validator';
import { isMobilePhone } from 'validator';

export const required = (value, props) => {
  if (!value || (props.isCheckable && !props.checked) || value === '0,00€') {
    return 'Pflichtfeld!';
  }
};

export const email = value => {
  if (!isEmail(value)) {
    return `Die E-Mail-Adresse "${value}" ist ungültig. Bitte überprüfen Sie die Eingabe.`;
  }
};

export const phone = value => {
  if (!isMobilePhone(value)) {
    return `${value} ist keine valide Telefonnummer.`;
  }
};



// WEBPACK FOOTER //
// ./src/Validation/GeneralValidators.js